export const LINKED_RECORD_TAB_INDEX: number = 1;
